module.exports = __webpack_public_path__ + "static/betters-image1-55d3c9d2c48da721280a6386e14468f1.png";